import { StringValidator } from './StringValidator'

export class EqualsToValidator extends StringValidator {
    supplier: () => string
    message: string

    constructor(supplier: () => string, message: string) {
        super()
        this.supplier = supplier
        this.message = message
    }

    isValidString(value: string): boolean {
        return this.supplier() === value
    }

    getMessage = () => this.message
}
